<script>
import {nextTick} from 'vue';

export default {
  props: {
    currentTotal: 0
  },
  data() {
    return {
      container: null,
      isOpen: false,
      hasStarted: false,
      config: {
        isAnswered: [],
        current: 1,
        total: 0,
        points: 0,
      }
    }
  },
  mounted() {
    this.container = document.querySelector('.js-vue-quiz');
    this.config.total = this.currentTotal;
    this.addEventListeners();
  },
  watch: {
    // ...
  },
  methods: {
    addEventListeners() {
      const clickableElements = this.container.querySelectorAll('.checkbox');
      clickableElements.forEach(element => {
        element.addEventListener('click', this.triggerStartDatalayer);
      });
    },
    triggerStartDatalayer: function () {
      if (!this.hasStarted) {
        console.log('form started');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'form_start',
          form_name: 'quiz - ' + this.container.closest('[data-event-topic]').dataset.eventTopic.replace(/(<([^>]+)>)/gi, ""),
          form_destination: window.location.href,
        });
        this.hasStarted = true;
      }
    },
    triggerSubmitDatalayer: function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'form_submit',
        form_name: 'quiz - ' + this.container.closest('[data-event-topic]').dataset.eventTopic.replace(/(<([^>]+)>)/gi, ""),
        form_destination: window.location.href,
      });
    },
    open: function (event) {
      this.isOpen = true;
      this.container.scrollIntoView(true);
      this.triggerStartDatalayer();

      let target = event.target;
      let clickText = target.dataset.eventClicktext;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'nfx_event',
        event_section: target.closest('section').getAttribute('id'),
        event_modul: 'Quiz',
        event_element: 'textlink',
        event_thema: target.closest('[data-event-topic]').dataset.eventTopic,
        event_klicktext: clickText.replace(/(<([^>]+)>)/gi, ""),
        event_target: '',
      });
    },

    toggle: function (event) {
      let target = event.target;
      target.parentNode.classList.toggle('is-checked');
    },

    check: function () {
      let question = this.container.querySelector('.js-question-' + this.config.current);
      if (!this.config.isAnswered.includes(this.config.current)) {
        this.triggerStartDatalayer();
        this.config.isAnswered.push(this.config.current);
        let answers = question.querySelectorAll('.quiz-answer');
        let isCorrect = true;

        answers.forEach((item) => {
          let checkbox = item.querySelector('input');
          if (item.dataset.control === '1' && checkbox.checked) {
            item.classList.add('is-success');
          } else if (item.dataset.control === '0' && !checkbox.checked) {
            item.classList.add('is-danger');
          } else if (item.dataset.control === '1' && !checkbox.checked) {
            item.classList.add('is-success');
            isCorrect = false;
          } else {
            item.classList.add('is-danger');
            isCorrect = false;
          }
        });

        if (isCorrect) {
          this.config.points++;
        }
      } else if (question.dataset.hasSnippet === 'true' && !this.config.isAnswered.includes(this.config.current + '_ad')) {
        this.config.isAnswered.push(this.config.current + '_ad');
        this.container.scrollIntoView();
        question.dataset.hasSnippet = 'false';
      } else {
        // once displayed, remove ad snippet again
        if (this.config.isAnswered.includes(this.config.current + '_ad')) {
          const index = this.config.isAnswered.findIndex(item => item === this.config.current + '_ad');
          if (index !== -1) {
            this.config.isAnswered.splice(index, 1);
          }
        }

        this.config.current++;
        this.container.scrollIntoView();
      }

      if (this.config.current > this.config.total) {
        this.triggerSubmitDatalayer();
      }
    },

    triggerSnapchatClick: function () {
      if (document.querySelector('.snapchat-share-button')) {
        document.querySelector('.snapchat-share-button').click();
      }
    }
  },
  components: {}
};
</script>
